import React from 'react'
import cx from 'classnames'
import { useCallback } from 'sb-hooks'
import { useIntl } from 'sb-react-intl'
import Icon from 'components/_new/ui/Icon/Icon'

import messages from './messages'
import s from './SelectableStar.scss'


type SelectableStarProps = {
  className?: string
  value: number
  checked: boolean
  onClick: (value: number) => void
}

const SelectableStar: React.FunctionComponent<SelectableStarProps> = ({ className, value, checked, onClick }) => {
  const intl = useIntl()

  const handleClick = useCallback(() => {
    onClick(value)
  }, [ onClick, value ])

  return (
    <button
      className={cx(s.star, className)}
      type="button"
      role="radio"
      aria-checked={checked}
      aria-label={intl.formatMessage(messages.label, { value })}
      onClick={handleClick}
    >
      <Icon
        name="star"
        color={checked ? 'brand' : 'gray-30'}
        className={s.icon}
        noWrapper
      />
    </button>
  )
}


export default SelectableStar
